import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS849 = {
  ID: 7,
  Name: 'CMS-849 Seat Lift Mechanisms',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-849/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 90,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 97,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 104,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 126,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 133,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 140,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 176,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 183,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 190,
          y: 31,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 16,
          y: 40,
          width: 98,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 16,
          y: 44,
          width: 98,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 17,
          y: 53.5,
          width: 10,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 28.5,
          y: 53.5,
          width: 10,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 41.5,
          y: 53.5,
          width: 14,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 72,
          y: 53.5,
          width: 42,
        },
        {
          name: 'Supplier Name and Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 118,
          y: 40,
          width: 83,
          height: 13,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 118,
          y: 53.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 130,
          y: 53.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 143,
          y: 53.5,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 175,
          y: 53.5,
          width: 26,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 41,
          y: 58.5,
          width: 19,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 128,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 135,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 141,
          y: 58.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 154,
          y: 58.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 175,
          y: 58.5,
          width: 6,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 193,
          y: 58.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 84,
          y: 64.5,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 1 }),
          x: 84,
          y: 69.6,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 2 }),
          x: 84,
          y: 74.7,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 3 }),
          x: 84,
          y: 79.8,
          width: 22,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 117,
          y: 67.6,
          width: 84,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 117,
          y: 71.7,
          width: 84,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 119,
          y: 81,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 131,
          y: 81,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 143,
          y: 81,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 176,
          y: 81,
          width: 25,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 69,
          y: 93.5,
          width: 9,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 136,
          y: 93.5,
          width: 65,
        },
        {
          name: 'Does the patient have severe arthritis of the hip or knee?',
          type: 'radio',
          options: [
            {
              x: 18,
              y: 109.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 26.5,
              y: 109.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 35,
              y: 109.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Does the patient have a severe neuromuscular disease?',
          type: 'radio',
          options: [
            {
              x: 18,
              y: 116.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 26.5,
              y: 116.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 35,
              y: 116.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Is the patient completely incapable of standing up from a regular armchair or any chair in his/her home?',
          type: 'radio',
          options: [
            {
              x: 18,
              y: 123.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 26.5,
              y: 123.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 35,
              y: 123.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Once standing, does the patient have the ability to ambulate?',
          type: 'radio',
          options: [
            {
              x: 18,
              y: 130,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 26.5,
              y: 130,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 35,
              y: 130,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Have all appropriate therapeutic modalities to enable the patient to transfer from a chair to a standing position (eg, medication, physical therapy) been tried and failed? If YES, this is documented in the patient’s medical records',
          type: 'radio',
          options: [
            {
              x: 18,
              y: 138.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 26.5,
              y: 138.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 35,
              y: 138.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'NAME OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 26,
          y: 148,
          width: 62,
        },
        {
          name: 'TITLE OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 99,
          y: 148,
          width: 40,
        },
        {
          name: 'EMPLOYER OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 155,
          y: 148,
          width: 46,
        },
        {
          name: '(1) Narrative description of all items, accessories and options ordered; (2) Supplier’s charge; and (3) Medicare Fee Schedule Allowance for each item, accessory, and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 15,
          y: 168,
          width: 186,
          height: 58,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 51,
          y: 249,
          width: 90,
          height: 10,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 161,
          y: 255.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 169,
          y: 255.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 177,
          y: 255.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS849;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-849.js